const basePath = '/assets/pixi-assets/crash-game/'

const themeOneCrashBackground = `${basePath}images/ultra-crash-bg.png`
const themeTwoCrashBackground = `${basePath}images/Bg2.png`

export const path = {
  imagePath: basePath + "images/",
  spriteSheetsPath: basePath + "spriteSheets/",
  fontPath: basePath + "fonts/",
}

export const crashBackgroundAssets = {
  default: {
    alias: 'crashBgThemeOne',
    src: themeOneCrashBackground
  },
  'theme-one': {
    alias: 'crashBgThemeOne',
    src: themeOneCrashBackground
  },
  'theme-two': {
    alias: 'crashBgThemeTwo',
    src: themeTwoCrashBackground
  }
}

export const getCrashBackgroundAsset = (themeSlug) => crashBackgroundAssets[themeSlug] || crashBackgroundAssets.default

const axisGapValue = 75

export const settings = {
  originalWidth: 1920,
  originalHeight: 1080,
  axisGap: axisGapValue,
  xCorrectedPos: axisGapValue * 1.8,
  yCorrectedPos: axisGapValue * 2.2, // 75

  totalDivisions: 10,
  graphSpeed: 20,

  assetsProgress: {
    bar: {
      backgroundColor: '#4cd137',
      border: 4,
      borderColor: '#FFFFFF',
      fillColor: '#e55039',
      height: 30,
      radius: 25,
      width: 550,
    },
    text: {
      visible: true,
      fill: 0xffffff,
      fontSize: 30,
    }
  },

  startGameProgress: {
    bar: {
      backgroundColor: '#220A06',
      border: 2,
      borderColor: '#9d4c36',
      fillColor: '#FFB823',
      height: 11,
      radius: 0,
      width: 285,
    },
    text: {
      visible: false,
      fill: 0xffffff,
      fontSize: 30,
    }
  }
}

export const getThemeTwoLayout = (width, height) => {
  const isPortrait = typeof window !== 'undefined' ? (window.innerWidth < window.innerHeight) : (width < height);
  
  if (isPortrait) {
    const isTablet = width >= 600;
    return {
      isPortrait: true,
      multiplierY: 55,
      multiplierFontSize: isTablet ? 24 : 20,
      multiplierLineHeight: isTablet ? 28 : 24,
      multiplierPaddingX: isTablet ? 32 : 24,
      multiplierPaddingY: isTablet ? 14 : 12,
      multiplierBorderRadius: isTablet ? 12 : 10,
      rocketScaleMax: isTablet ? 0.55 : 0.48,
      graphLineThickness: isTablet ? 8 : 6,
      graphHeightScale: 0.85,
    };
  } else {
    return {
      isPortrait: false,
      multiplierYMin: 90,
      multiplierYFactor: 100,
      multiplierFontSize: 52,
      multiplierLineHeight: 60,
      multiplierPaddingX: 165,
      multiplierPaddingY: 85,
      multiplierBorderRadius: 14,
      rocketScaleFactor: 3.5,
      graphLineThickness: 6,
      graphHeightScale: 0.75,
    };
  }
};
